// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bcr_a bhj_b bhj_tu bhj_qz bhj_ra bhj_uo","PanelFooter--link":"bcr_b"};